import JumboContent from "@jumbo/components/JumboContent";
import JumboDdMenu from "@jumbo/components/JumboDdMenu";
import { Card, Grid, Stack, Typography } from "@mui/material";
import Cities from "app/shared/metrics/Cities";
import Properties from "app/shared/metrics/Properties";
import QueriesStatistics from "app/shared/metrics/QueriesStatistics";
import VisitsStatistics from "app/shared/metrics/VisitsStatistics";
import React from "react";
import { DateRangeIcon } from "@mui/x-date-pickers";
import Div from "@jumbo/shared/Div";
import LineChartSales from "app/shared/metrics/SalesStatistics/LineChartSales";
import ChartOrderRevenue from "app/shared/metrics/SalesStatistics/ChartOrderRevenue";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { adminDataItems } from "app/shared/metrics/SalesStatistics/data";
import DealsAnalytics from "app/shared/metrics/DealsAnalytics";
import EarningExpenses from "app/shared/metrics/EarningExpenses";

export const AdminData1 = [
  {
    name: "Total Sales",
    amount: "48,548",
  },
  {
    name: "Total Memo",
    amount: "6,478",
  },
  {
    name: "Total Purchase",
    amount: "$210,213",
  },
  {
    name: "Total consignment",
    amount: "$692,874",
  },
  // {
  //   name: "Total Payable",
  //   amount: "$692,874",
  // },
  // {
  //   name: "Total Receivable",
  //   amount: "$692,874",
  // },
  // {
  //   name: "Total Single Stock",
  //   amount: "$692,874",
  // },
  // {
  //   name: "Total Bulk Stock",
  //   amount: "$692,874",
  // },
  // {
  //   name: "Total Jewelry Stock",
  //   amount: "$692,874",
  // },
];

export const AdminData2 = [
  {
    name: "Total Single Stock",
    amount: "$692,874",
  },
  {
    name: "Total Bulk Stock",
    amount: "$692,874",
  },
  {
    name: "Total Jewelry Stock",
    amount: "$692,874",
  },
];

export const AdminData3 = [
  {
    name: "Total Income",
    amount: "48,548",
  },
  {
    name: "Total Expense",
    amount: "6,478",
  },
];

export const AdminData4 = [
  {
      name: "Total Payable",
      amount: "$692,874",
    },
    {
      name: "Total Receivable",
       amount: "$692,874",
    }];

const AdminDashboard = () => {
  const Item = styled("div")(({ theme }) => ({
    color: theme.palette.common.black,
    marginBottom: 16,
    width: "15.5%",
    [theme.breakpoints.down("lg")]: {
      width: "16.5%",
    },
    [theme.breakpoints.down("md")]: {
      width: "33.3%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50%",
    },
    padding: theme.spacing(0, 2),
  }));
  const theme = useTheme();

  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={12} lg={3}>
          <Properties />
        </Grid>
        <Grid item xs={12} lg={3}>
          <Cities />
        </Grid>
        <Grid item xs={12} lg={3}>
          <VisitsStatistics />
        </Grid>
        <Grid item xs={12} lg={3}>
          <QueriesStatistics />
        </Grid>
      </Grid>
      <Grid container spacing={5}>
        <Grid container sx={{ marginTop: 5 }} item xs={12} md={7}>
          <Card style={{ maxWidth: "auto", width: "100%" }}>
            <JumboContent
              // title={
              //   <Typography variant={"h5"} color={"common.white"}>
              //     {"Admin"}
              //   </Typography>
              // }
              action={<JumboDdMenu />}
              bgColor={theme.palette.primary.main}
              sx={{ color: "common.white" }}
            >
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                sx={{ p: (theme) => theme.spacing(0, 1, 2) }}
              >
                {AdminData1.map((item, key) => (
                  <Item key={key}>
                    <Typography variant={"body1"} color={"common.white"} mb={1}>
                      <DateRangeIcon
                        fontSize={"small"}
                        sx={{ verticalAlign: "middle", mr: 1, mt: -0.5 }}
                      />
                      {item.amount}
                    </Typography>
                    <Typography variant={"h6"} color={"common.white"} mb={0}>
                      {item.name}
                    </Typography>
                  </Item>
                ))}
              </Stack>
            </JumboContent>
            <JumboContent>
              <Grid container>
                <Grid item xs={12} lg={12}>
                  <Div
                    sx={{
                      p: (theme) => theme.spacing(3, 2, 3, 0),
                    }}
                  >
                    <LineChartSales />
                  </Div>
                </Grid>
                {/* <Grid item xs={12} lg={6}>
                    <Div
                      sx={{
                        p: (theme) => theme.spacing(3, 0, 3, 2),
                        [theme.breakpoints.up("lg")]: {
                          borderLeft: (theme) =>
                            `solid 2px ${theme.palette.divider}`,
                        },
                        [theme.breakpoints.down("lg")]: {
                          borderTop: (theme) =>
                            `solid 2px ${theme.palette.divider}`,
                        },
                      }}
                    >
                      <ChartOrderRevenue data={adminDataItems} />
                    </Div>
                  </Grid> */}
              </Grid>
            </JumboContent>
          </Card>
        </Grid>
        <Grid container sx={{ marginTop: 5 }} item xs={12} md={5}>
          <Card style={{ maxWidth: "auto", width: "100%" }}>
            <JumboContent
              // title={
              //   <Typography variant={"h5"} color={"common.white"}>
              //     {"Admin"}
              //   </Typography>
              // }
              action={<JumboDdMenu />}
              bgColor={theme.palette.primary.main}
              sx={{ color: "common.white" }}
            >
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                sx={{ p: (theme) => theme.spacing(0, 1, 2) }}
              >
                {AdminData2.map((item, key) => (
                  <Item key={key}>
                    <Typography variant={"body1"} color={"common.white"} mb={1}>
                      <DateRangeIcon
                        fontSize={"small"}
                        sx={{ verticalAlign: "middle", mr: 1, mt: -0.5 }}
                      />
                      {item.amount}
                    </Typography>
                    <Typography variant={"h6"} color={"common.white"} mb={0}>
                      {item.name}
                    </Typography>
                  </Item>
                ))}
              </Stack>
            </JumboContent>
            <JumboContent>
              <Grid container>
                {/* <Grid item xs={12} lg={12}>
                <Div
                  sx={{
                    p: (theme) => theme.spacing(3, 2, 3, 0),
                  }}
                >
                  <LineChartSales />
                </Div>
              </Grid> */}
                <Grid item xs={12} lg={12}>
                  <Div
                    sx={{
                      p: (theme) => theme.spacing(3, 0, 3, 2),
                      [theme.breakpoints.up("lg")]: {
                        borderLeft: (theme) =>
                          `solid 2px ${theme.palette.divider}`,
                      },
                      [theme.breakpoints.down("lg")]: {
                        borderTop: (theme) =>
                          `solid 2px ${theme.palette.divider}`,
                      },
                    }}
                  >
                    <ChartOrderRevenue data={adminDataItems} />
                  </Div>
                </Grid>
              </Grid>
            </JumboContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container spacing={5} >
        <Grid container sx={{ marginTop: 5 ,height: "100%" }} item xs={12} md={7}>
          <Card style={{ maxWidth: "auto", width: "100%",height: "100%" }}>
            <JumboContent
              // title={
              //   <Typography variant={"h5"} color={"common.white"}>
              //     {"Admin"}
              //   </Typography>
              // }
              action={<JumboDdMenu />}
              bgColor={theme.palette.primary.main}
              sx={{ color: "common.white" }}
            >
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                sx={{ p: (theme) => theme.spacing(0, 1, 2) }}
              >
                {AdminData3.map((item, key) => (
                  <Item key={key}>
                    <Typography variant={"body1"} color={"common.white"} mb={1}>
                      <DateRangeIcon
                        fontSize={"small"}
                        sx={{ verticalAlign: "middle", mr: 1, mt: -0.5 }}
                      />
                      {item.amount}
                    </Typography>
                    <Typography variant={"h6"} color={"common.white"} mb={0}>
                      {item.name}
                    </Typography>
                  </Item>
                ))}
              </Stack>
            </JumboContent>
            <JumboContent style={{height:"100%"}}>
              <Grid container style={{height:"100%"}}>
                <Grid item xs={12} lg={12} style={{height:"100%"}}>
                  <EarningExpenses style={{height:"100%"}} />
                </Grid>
              </Grid>
            </JumboContent>
          </Card>
        </Grid>
        <Grid container sx={{ marginTop: 5 }} item xs={12} md={5}>
          <Card style={{ maxWidth: "auto", width: "100%" }}>
            <JumboContent
              // title={
              //   <Typography variant={"h5"} color={"common.white"}>
              //     {"Admin"}
              //   </Typography>
              // }
              action={<JumboDdMenu />}
              bgColor={theme.palette.primary.main}
              sx={{ color: "common.white" }}
            >
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                sx={{ p: (theme) => theme.spacing(0, 1, 2) }}
              >
                {AdminData4.map((item, key) => (
                  <Item key={key}>
                    <Typography variant={"body1"} color={"common.white"} mb={1}>
                      <DateRangeIcon
                        fontSize={"small"}
                        sx={{ verticalAlign: "middle", mr: 1, mt: -0.5 }}
                      />
                      {item.amount}
                    </Typography>
                    <Typography variant={"h6"} color={"common.white"} mb={0}>
                      {item.name}
                    </Typography>
                  </Item>
                ))}
              </Stack>
            </JumboContent>
            <JumboContent>
              <Grid container>
                {/* <Grid item xs={12} lg={12}>
                <Div
                  sx={{
                    p: (theme) => theme.spacing(3, 2, 3, 0),
                  }}
                >
                  <LineChartSales />
                </Div>
              </Grid> */}
                <Grid item xs={12} lg={12}> 
                  <DealsAnalytics />
                  {/* <Div
                    sx={{
                      p: (theme) => theme.spacing(3, 0, 3, 2),
                      [theme.breakpoints.up("lg")]: {
                        borderLeft: (theme) =>
                          `solid 2px ${theme.palette.divider}`,
                      },
                      [theme.breakpoints.down("lg")]: {
                        borderTop: (theme) =>
                          `solid 2px ${theme.palette.divider}`,
                      },
                    }}
                  >
                    <ChartOrderRevenue data={adminDataItems} />
                  </Div> */}
                </Grid> 
              </Grid>
            </JumboContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default AdminDashboard;
